import { jsx as l } from "react/jsx-runtime";
import { useTranslation as g, ContactSlugEnum as o, FormInput as y, getContactFieldTitle as b, FormInputPhone as d, getContactSlugName as c, FormSelect as E, getCountryData as q } from "@systemeio/ui";
import { useVisitorInfoStore as N } from "../store/index.mjs";
import { useLocaleContext as T } from "../providers/use-locale-provider.mjs";
const x = ({
  value: e,
  error: t,
  field: u,
  onChange: a,
  contactFields: m
}) => {
  var r;
  const { locale: p } = T(), { visitorInfo: n } = N(), { t: s } = g(), C = (r = m[o.Country]) != null && r.value ? m[o.Country].value : (n == null ? void 0 : n.country) ?? void 0;
  switch (u.slug) {
    case o.Country:
      return /* @__PURE__ */ l(
        E,
        {
          label: c(u.slug, s),
          className: "focus:!border-THEME-primary",
          required: u.required,
          data: q(p),
          value: e,
          withoutCloseIcon: !0,
          onChange: (i) => a(i),
          error: t == null ? void 0 : t.join(", ")
        }
      );
    case o.PhoneNumber:
      return /* @__PURE__ */ l(
        d,
        {
          label: c(u.slug, s),
          inputClassName: "focus:!border-THEME-primary",
          required: u.required,
          value: e,
          onChange: a,
          initialCountry: C,
          error: t == null ? void 0 : t.join(", ")
        }
      );
    default:
      return /* @__PURE__ */ l(
        y,
        {
          label: b(u, s),
          inputClassName: "focus:!border-THEME-primary",
          required: u.required,
          value: e,
          onChange: ({ target: { value: i } }) => a(i),
          error: t == null ? void 0 : t.join(", ")
        },
        u.slug
      );
  }
};
export {
  x as default
};
